import { Space, Row, Col, InputNumber, Collapse } from "antd";
import { Guess } from "../types/Guess";
import { SlidersOutlined } from '@ant-design/icons';


interface ConfigurationFormProps {
    values: number[],
    setValues: any,
    computeDistances: any,
    computeBounds: any,
    setRankAmount: any,
    rankAmount: number,
    guesses: Guess[],
}

export const ConfigurationForm = ({ values, setValues, computeBounds, computeDistances, setRankAmount, rankAmount, guesses }: ConfigurationFormProps) => {

    return (
        <Collapse
            defaultActiveKey={['1']}
            items={[
                {
                    key: '1',
                    label: 'Schätzwerte einstellen',
                    extra: <SlidersOutlined />,
                    children: <Space direction="vertical" size="middle" style={{ display: 'flex' }}>

                        <Row style={{ float: "right" }}>
                            <Col>
                                <span className="valueInput label">Schätzwert 1: </span>
                            </Col>
                            <Col>
                                <InputNumber
                                    className="valueInput ant-card-bordered"
                                    size="large"
                                    onChange={(num) => {
                                        if (num) {
                                            const newValues = [...values];
                                            newValues[0] = num;
                                            setValues(newValues);
                                            computeDistances(newValues);
                                        }
                                    }}
                                    value={values[0]} />
                            </Col>
                        </Row>
                        <Row style={{ float: "right" }}>
                            <Col>
                                <span className="valueInput label">Schätzwert 2: </span>
                            </Col>
                            <Col>
                                <InputNumber
                                    className="valueInput ant-card-bordered"
                                    size="large"
                                    onChange={(num) => {
                                        if (num) {
                                            const newValues = [...values];
                                            newValues[1] = num;
                                            setValues(newValues);
                                            computeDistances(newValues);
                                        }
                                    }}
                                    value={values[1]} />
                            </Col>
                        </Row>
                        <Row style={{ float: "right" }}>
                            <Col>
                                <span className="valueInput label">Schätzwert 3: </span>
                            </Col>
                            <Col>
                                <InputNumber
                                    className="valueInput ant-card-bordered"
                                    size="large"
                                    onChange={(num) => {
                                        if (num) {
                                            const newValues = [...values];
                                            newValues[2] = num;
                                            setValues(newValues);
                                            computeDistances(newValues);
                                        }
                                    }}
                                    value={values[2]} />
                            </Col>
                        </Row>
                        <Row style={{ float: "right" }}>
                            <Col>
                                <span className="valueInput label">Schätzwert 4: </span>
                            </Col>
                            <Col>
                                <InputNumber
                                    className="valueInput ant-card-bordered"
                                    size="large"
                                    onChange={(num) => {
                                        if (num) {
                                            const newValues = [...values];
                                            newValues[3] = num;
                                            setValues(newValues);
                                            computeDistances(newValues);
                                        }
                                    }}
                                    value={values[3]} />
                            </Col>
                        </Row>
                        <Row style={{ float: "right" }}>
                            <Col>
                                <span className="valueInput label">Plätze: </span>
                            </Col>
                            <Col>
                                <InputNumber
                                    className="valueInput ant-card-bordered"
                                    size="large"
                                    onChange={(num) => {
                                        if (num) {
                                            setRankAmount(num);
                                            computeBounds(guesses, num);
                                        }
                                    }}
                                    value={rankAmount} />
                            </Col>
                        </Row>
                    </Space>
                }
            ]}
        />

    )
}